/**
 * Marks the app's own message dialog (`DialogService.showMessage`) when it shows an error, so the CoPilot's global
 * "Ask CoPilot" hook can find it (CU-14zefhy1qnh). No Angular imports: unit-tested without a TestBed.
 */

/** nzClassName put on the `.ant-modal` of a message dialog that shows an error */
export const ERROR_DIALOG_CLASS = 'di-error-dialog';

/** an i18n key such as `common.error` / `runs.messages.error` */
const ERROR_KEY = /(^|\.)error$/i;
/** a shown title such as "Error", "Recording Error", "Save failed" */
const ERROR_TITLE = /\b(error|errors|failed|failure)\b/i;

/**
 * True when a message dialog shows an error, judged by its title: the raw title (usually an i18n key such as
 * `common.error`) or the translated one. Other message dialogs ("Success", "AI Response", notices) stay as they are.
 */
export function isErrorDialogTitle(rawTitle: any, shownTitle?: any): boolean {
    if (typeof rawTitle === 'string' && ERROR_KEY.test(rawTitle.trim())) {
        return true;
    }
    return [rawTitle, shownTitle].some((t) => typeof t === 'string' && ERROR_TITLE.test(t));
}

/** Adds the error-dialog class to a modal's existing nzClassName (kept as is when the class is already there). */
export function withErrorDialogClass(className?: string | null): string {
    const classes = String(className || '')
        .split(/\s+/)
        .filter((c) => !!c);
    if (classes.indexOf(ERROR_DIALOG_CLASS) < 0) {
        classes.push(ERROR_DIALOG_CLASS);
    }
    return classes.join(' ');
}
